// Crew data export + erase of private data (GDPR) - the page's rules (src/components/CrewDataPanel.jsx; server: api/_crewData.js, sql/final-fix.sql).
// Only the Captain or management of the vessel sees the buttons (the database decides again: hc_crew_data_admin).

// OFF until sql/final-fix.sql has run on the live database and the feature is released: no button on the Crew page, the API
// (api/_crewData.js) refuses, the daily crew-data job does nothing. Switch on here - one place for the page and the server.
export const CREW_DATA_ENABLED = true

// the vessel's own login (Captain), a Captain crew login, or a management / company-team login - and only while the feature is on
export function canManageCrewData(config, enabled = CREW_DATA_ENABLED) {
  if (!enabled) return false
  if (!config || !config.id) return false
  if (config.accountType === 'crew') return config.role === 'captain'
  return true
}

// "Erase personal data" only when the typed name is the crew member's name (spaces / case do not matter)
export const norm = s => String(s == null ? '' : s).trim().replace(/\s+/g, ' ').toLowerCase()
export const nameConfirmed = (typed, name) => !!norm(name) && norm(typed) === norm(name)

const TABLE_LABELS = {
  crew: 'Crew record', crew_private: 'Passport, ID, date of birth, next of kin, contact', crew_docs: 'Crew documents', crew_photo: 'Crew photo',
  crew_accounts: 'Crew login on this vessel', ai_threads: 'Their own AI chats', crew_leave: 'Leave', hours_rest: 'Hours of rest',
  sealog_rest: 'Hours of rest (imported)', oil_record_book: 'Oil Record Book', engine_log: 'Engine log', day_log: 'Deck log',
  drill_records: 'Drill records', checklist_instances: 'Checklists / drills', emergency_records: 'Emergency records', lsa_checks: 'LSA / FFE checks',
  officer_monthly_reviews: 'Officer reviews', sop_runs: 'Procedure records', manual_acks: 'Manual read-and-understood', crew_list: 'Crew lists',
  passage_plans: 'Passage plans', risk_assessments: 'Risk assessments', manuals: 'Manual approvals', permits: 'Permits to work',
  permit_signons: 'Permits to work', permit_events: 'Permits to work', permit_gas_tests: 'Permits to work', ptw_jobs: 'Permits to work',
  crew_movements: 'Crew movements', crew_log: 'Crew log', handovers: 'Handovers', handover_private: 'Handovers', duty_rotas: 'Duty rotas',
  watch_schedules: 'Watch schedules', todo_items: 'To Do', todo_comments: 'To Do', todo_lists: 'To Do', todo_folders: 'To Do',
  diary_entries: 'Diary', calendar_events: 'Calendar', ai_proposals: 'AI data', ai_audit: 'AI data', ai_usage: 'AI data',
  vessel_memory: 'AI data', activity_events: 'Activity feed', feedback: 'Feedback', app_notices: 'Notices',
  email_settings: 'Daily e-mail list', email_log: 'E-mail log', app_errors: 'Error log',
}
export const tableLabel = t => TABLE_LABELS[t] || (String(t).startsWith('ism_') ? 'ISM audits' : /^(apa_|charter_apa|petty_cash|purchase_order)/.test(t) ? 'Accounting records' : String(t).replace(/_/g, ' '))

// hc_crew_prepare / the erase result -> the page's two lists (what goes; vessel records that stay exactly as they are): { label, count, why }
// summed per label (no column detail on the page). Nothing is anonymised: vessel records keep the name (sql/final-fix.sql).
function group(list) {
  const m = new Map()
  for (const x of list || []) {
    if (!x || !x.count) continue
    const k = tableLabel(x.table)
    const g = m.get(k) || { label: k, count: 0, why: x.why || '' }
    g.count += Number(x.count) || 0
    m.set(k, g)
  }
  return [...m.values()].sort((a, b) => b.count - a.count || a.label.localeCompare(b.label))
}
export function prepareView(p) {
  if (!p) return null
  return {
    name: p.name || '',
    deleted: group([...(p.own || []), ...(p.delete || p.deleted || [])]),
    kept: group(p.keep || p.kept || []),
    erasedAt: p.erased_at || null,
    files: Array.isArray(p.files) ? p.files.map(f => f.name) : [],   // the erase result has { deleted, failed } here instead
    filesKept: (Array.isArray(p.files_kept) ? p.files_kept : []).filter(f => f.count > 0),
  }
}

// the Crew page reminder (Captain / management only, while the feature is on): crew who left more than this many months ago and are
// not erased yet - the database decides who (hc_crew_erase_due: not onboard, the later of the contract end and the last sign-off)
export const ERASE_AFTER_MONTHS = 6
export function eraseReminder(due, enabledFor) {
  const list = Array.isArray(due) ? due.filter(d => d && d.crew_id) : []
  if (!enabledFor || !list.length) return null
  return { title: list.length === 1 ? '1 crew member left more than ' + ERASE_AFTER_MONTHS + ' months ago' : list.length + ' crew members left more than ' + ERASE_AFTER_MONTHS + ' months ago',
    ask: 'Erase personal data?', people: list.map(d => ({ id: d.crew_id, name: d.name || 'Crew member', leftOn: d.left_on || '' })) }
}
